import { ChangeEvent } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PageLink } from '@/components/TopPageLinks/TopPageLinks.component';
import { Paths } from '@/types/routes';
import * as Styles from './Home.styles';

type HomeComponentProps = {
  searchValue?: string;
  onSearch: (event: ChangeEvent<HTMLInputElement>) => void;
  pageLinks: PageLink[];
};

const HomeComponent = ({
  searchValue = '',
  pageLinks,
  onSearch,
}: HomeComponentProps): JSX.Element => {
  const location = useLocation();
  const isIndexRoute =
    location.pathname === Paths.HOME || location.pathname === '/home';

  // Command center (index route): full-width, no sidebar, no tabs
  if (isIndexRoute) {
    return (
      <div data-testid="home">
        <Styles.BodyContainer>
          <Outlet />
        </Styles.BodyContainer>
      </div>
    );
  }

  // Sub-routes (personal info, attachments): keep tabs + search header
  return (
    <div data-testid="home">
      <Styles.SidePanel />
      <Styles.PageContent>
        <Styles.HeaderContainer>
          <Styles.HeaderLinks pageLinks={pageLinks} hideBackButton />
          <Styles.SearchInput
            id="home-search-input"
            value={searchValue}
            onChangeHandler={onSearch}
          />
        </Styles.HeaderContainer>
        <Styles.BodyContainer>
          <Outlet />
        </Styles.BodyContainer>
      </Styles.PageContent>
    </div>
  );
};

export default HomeComponent;
